var Theme;

jQuery(document).ready(function(){

	Theme = {

		/**
		 * Init
		 */
		init:function(){

			// Cache elements
			Theme.w = jQuery(window);
			Theme.html = jQuery('html');
			Theme.body = jQuery('body');
			Theme.toggleNavButton = jQuery('.toggle-nav');
			Theme.toggleSubNavButton = jQuery('.menu-item-has-children > a');
			Theme.mobileWidth = 1000;

			// Go!
			Theme.bindings();

		},

		bindings:function(){

			// Lightbox
			jQuery('a[href$=".jpg"],a[href$=".jepg"],a[href$=".png"]').fancybox();

			// Toggle nav
			Theme.toggleNavButton.click(function(e){
				e.preventDefault();
				Theme.toggleNav();
			});

			// Toggle subnav
			console.log(Theme.toggleSubNavButton);
			Theme.toggleSubNavButton.click(function(e){
				console.log('click');
				if ( Theme.mobileWidth < Theme.w.width() )
					return;

				e.preventDefault();

				jQuery(this).next().slideToggle();

			});

		},

		toggleNav:function(){

			Theme.body.toggleClass( 'nav-visible' );

		},

	};

	Theme.init();

});
